<div class="basin-display-flex basin-flex-column">
  <div
    *ngFor="let item of agentSettingsList"
    class="basin-display-flex basin-py-2 basin-align-items-center basin-flex-row basin-justify-content-space-between basin-font-size-14 basin-line-height-18"
  >
    <div class="basin-display-flex basin-align-items-center">
      <div>{{ item.label }}</div>
      <div class="symbol-info tooltip-icon basin-pl-1 basin-color-light-gray" [pTooltip]="item.tooltip"></div>
    </div>

    <div>{{ item.value }}</div>
  </div>
</div>
